module.exports = __webpack_public_path__ + "fbb510b262db6a320dd90aa74eb86499.svg";